import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { vi_VN, NzI18nService, en_US, } from 'ng-zorro-antd/i18n';
import { Subscription } from 'rxjs';
import { AuthService } from './core/services/api/00auth.service';
import { StoresService } from './core/services/features/stores.service';
import { ConstantsService } from './core/utils/constants.service';
import { SendDataService } from './core/utils/send-data.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  auth: any;
  subscription: Subscription[] = [];
  emailGeneral = ConstantsService.idAdminGeneral;

  constructor(
    private i18n: NzI18nService,
    private translate: TranslateService,
    private authService: AuthService,
    private sendDataService: SendDataService,
    private api: StoresService
  ) { }

  ngOnInit() {
    this.auth = this.authService.getAuthFromLocalStorage();
    if (this.auth?.user?.idStore && this.auth?.user?.email !== this.emailGeneral) {
      this.findStoreById(this.auth?.user?.idStore);
    }

    if (this.auth?.user?.email === this.emailGeneral) {
      this.updateTimezone('Asia/Ho_Chi_Minh', 'us');
    }

    this.i18n.setLocale(vi_VN);
    this.translate.addLangs(['vi', 'en']);
    const browserLang = this.translate.getBrowserLang();
    let codeName = localStorage.getItem('codeName');
    if (codeName) {
      this.translate.setDefaultLang(codeName);
      this.translate.use(codeName);
    }
    else if (browserLang == 'vi' || browserLang == 'en') {
      this.translate.setDefaultLang(browserLang);
      this.translate.use(browserLang);
    } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
    }
  }

  /**
 * findStoreById
 */
  findStoreById(id: string) {
    if (id) {
      const filter = 'fields=timezoneApp,country';
      this.subscription.push(
        this.api.find(id, filter).subscribe(data => {

          if (data.timezoneApp && data.country) {
            this.updateTimezone(data.timezoneApp, data.country);
          }
        })
      );
    }
  }

  /**
 * Hàm updateTimezone dùng để set vào SendDataService
 */
  private updateTimezone(tz: string, country: string) {
    this.sendDataService.setTimezone(tz, country);
  }
}
